import { useCallback } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Listable } from 'listable'
import { useNavigate } from 'react-router-dom'
import Row from './row'
import Filters from '../filters'
import { hasRoles } from 'acl'
import {
  actions,
  config,
  constants
} from '../../module'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

const List = ({ model,userRoles }) => {
  const navigate = useNavigate()
  const renderItem = useCallback((item, index, itemProps) => {
    const onView = () => navigate(`${constants.PATH_SINGLE}/${item.id}`)
    return (
      <Row
        key={index}
        item={item}
        onView={onView}
        {...itemProps}/>
    )
  }, [navigate])
  // Prevents re-rendering if ids or data updated - no longer needed
  const { ids, filters, ...rest } = model

  return (
    <Listable
      actions={actions}
      config={config}
      filters={Filters}
      model={rest}
      renderItem={renderItem}
      actionButtons={
        <>
          {!(hasRoles(['fleetcoordinator'], userRoles)) && (
            <Stack
              flexDirection={{ xs: 'column', md: 'row' }}
              justifyContent='space-between'
              gap={1}>
              <Stack flexDirection="row" gap={2}>
                <Box width={{ xs: '100%', md: '180px' }}>
                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={() => navigate(constants.PATH_ADD)}>
                    Request Relief/Rental Vehicle
                  </Button>
                </Box>
              </Stack>
            </Stack>
          )}
        </>
      }/>
  )
}

List.propTypes = {
  model: PropTypes.object.isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
}

const mapStateToProps = ({ requestReliefVehicles, settings }) => ({
  model: requestReliefVehicles,
  userRoles: settings.roles,
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List)
